<template>
    <div class="tabs">
        <a v-for="tab in tabs"
           :key="tab.name"
           :class="{ active: tab.name === modelValue }"
           @click.prevent="$emit('update:modelValue', tab.name)">
            <i v-if="tab.icon"
               :class="tab.icon"
               class="fa-solid mobile-only"></i>
            <span :class="{ 'desktop-only': tab.icon }">
                {{ l(tab.label) }}
            </span>
            <span v-if="tab.badge"
                  class="label label-default">{{ tab.badge }}</span>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        /**
         * Array of tabs to display.
         *
         * If a tab has an `icon`, it's shown on mobile (in place of the label, for space) and the
         * label is shown on desktop. If a tab has no `icon`, the label is shown on both - so tabs
         * without icons yet (e.g. account/membership details) keep working as before.
         *
         * @param {{ name: string, label: string, badge?: number, icon?: string }[]}
         */
        tabs: {
            type: Array,
            required: true,
        },

        /**
         * Active tab name, set as v-model.
         */
        modelValue: {
            type: String,
            default: null,
        },
    },

    emits: ['update:modelValue'],
};
</script>
